export const languageElements = {
  items: {
    "field-ID": {
      hu: "#",
      de: "#",
      en: "#",
    },

    "field-INV_Type_ID": {
      hu: "Bizonylat típusa",
      de: "Dokumenttyp",
      en: "Type of document",
    },

    "field-InvoiceNum": {
      hu: "Számlaszám",
      de: "Re-Nr",
      en: "Invoice number",
    },

    "field-Ref_InvoiceNum": {
      hu: "Hivatkozott bizonylat",
      de: "Ref.Dokument",
      en: "Referred invoice",
    },

    "field-PartnerName": {
      hu: "Partner",
      de: "Partner",
      en: "Partner",
    },

    "field-Gross": {
      hu: "Bruttó",
      de: "Brutto",
      en: "Gross",
    },

    "field-Currency": {
      hu: "Devizanem",
      de: "Währung",
      en: "Currency",
    },

    "field-InvDate": {
      hu: "Dátum",
      de: "Re.Datum",
      en: "Date",
    },

    "field-DeliveryDate": {
      hu: "Teljesítés",
      de: "Leistungsdatum",
      en: "Deliverydate",
    },

    "field-DueDate": {
      hu: "Lejárat",
      de: "Za.Ziel",
      en: "Duedate",
    },

    "field-OverdueDays": {
      hu: "Késedelmes napok száma",
      de: "Überfällige Tage",
      en: "Overdue days",
    },

    "field-PaymentStatus": {
      hu: "Fizetési állapot",
      de: "Zahlungsstatus",
      en: "Payment status",
    },

    "flush-filter": {
      hu: "Adatok előszűrése",
      de: "Filter",
      en: "Filter",
    },

    "flush-data": {
      hu: "Számlák",
      de: "Rechnungen",
      en: "Invoices",
    },

    "paymentStatus-not-paid": {
      hu: "Nincs fizetve",
      de: "Nicht bezahlt",
      en: "Not paid",
    },

    "paymentStatus-bank-transferred": {
      hu: "Utalva",
      de: "Überwiesen",
      en: "Bank transferred",
    },

    "paymentStatus-paid": {
      hu: "Fizetve",
      de: "Bezahlt",
      en: "Paid",
    },

    "paymentStatus-cancelled": {
      hu: "Sztorno",
      de: "Storniert",
      en: "Cancelled",
    },

    "paymentStatus-summary-0": {
      hu: "Fizetve",
      de: "Bezahlt",
      en: "Paid",
    },

    "paymentStatus-unrecoverable": {
      hu: "Fizetve",
      de: "Bezahlt",
      en: "Paid",
    },

    pleaseSelect: {
      hu: "--- Kérem válasszon! ---",
      de: "--- Bitte wählen! ---",
      en: "--- Please select ---",
    },

    "field-PreparedBy": {
      hu: "Ügyintéző",
      de: "Sachbearbeiter",
      en: "Administrator",
    },

    "field-PreparedBy_Email": {
      hu: "Email",
      de: "Email",
      en: "Email",
    },

    "modal-download-title": {
      hu: "Fájlok letöltése",
      de: "Download Files",
      en: "Download files",
    },
  },
};
